import { inject, Service } from '@angular/core'

import { AppStore } from '@core/store'
import { MessagesService } from '@shared/services'
import { Venue } from '../../models/venue.model'
import { VenuesApi } from '../venues-api/venues-api'

/**
 * Centros de consumo del usuario. Salen de sus tags `cdc`: el gerente tiene uno
 * y el ejecutivo, todos los que atiende.
 */
@Service()
export class VenuesService {
  readonly #api = inject(VenuesApi)
  readonly #store = inject(AppStore)
  readonly #messages = inject(MessagesService)

  /** Centros a cargo del usuario, con su gerente cuando se conoce. */
  async getMyVenues(): Promise<Venue[]> {
    const venueTags = this.#store.currentUser()?.venueTags ?? []
    if (venueTags.length === 0) return []

    try {
      const [venues, managers] = await Promise.all([this.#api.getVenues(venueTags), this.#api.getManagers(venueTags)])

      return venues.map(venue => {
        const manager = managers.get(venue.tag)

        return manager ? { ...venue, manager } : venue
      })
    } catch {
      void this.#messages.error(null, 'No se pudieron cargar los centros de consumo')
      return []
    }
  }

  /** El centro del gerente: el primero de sus tags. */
  async getMyVenue(): Promise<Venue | null> {
    const [venue] = await this.getMyVenues()

    return venue ?? null
  }
}
